<template>
<div id="app">
  <v-app id="inspire">
    <v-app-bar
      app
      color="dark"
      dark
    >
    <v-toolbar-title>Graph Layout Labelling</v-toolbar-title>
    <v-spacer></v-spacer>
    <router-link to = "/" tag="button">
    <v-btn
            class="ma-2"
            large
            dark
            >User Login
            <v-icon dark> mdi-account </v-icon>
    </v-btn>
    </router-link>
    </v-app-bar>
    <v-main>
      <v-container
        fluid
        20
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="dark"
                dark
                flat
              >
                <v-toolbar-title>User Registration Form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model = "username"
                    label="Username"
                    name="Username"
                    type="text"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
              <router-link to="/" tag="button"><v-btn color="dark"> Go Back</v-btn></router-link>
                <v-spacer></v-spacer>
                    <v-btn color="dark" 
                      @click="insert_username"> Create</v-btn>
                    <div v-if=dialog>
                    <v-dialog 
                        v-model="dialog"
                        max-width="290">                    
                    <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                      Error
                    </v-card-title>
                    <v-card-text class= "text-md-body-1">{{error}}</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="dark"
                        text
                        @click="dialog = false">
                        OK
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</div>
</template>

<script>
import config from '@/config';

export default {
  name:'CreateUser',
  title: 'Create New User',
  data() {
    return{
      username: null,
      error: null,
      dialog:false
    }
    },
  methods:{
    insert_username: function (){
      if(!this.username){
        this.error = "Please enter an username."
        this.dialog = true
      }else{
        fetch(`${config.API_BASE_URL}/add_user`,{
            method: "POST",
            headers:{
              "Content-Type": "application/json"
            },
            body: JSON.stringify({user:this.username})  
        })
        .then(resp => {
          if (resp.status === 400){
            this.error = "The user name is already existed. Please enter another one."
            this.dialog = true
          }else{
            this.$router.push({path:'/instruction/'})
          }
          return resp.json()
        })
        .catch(err =>{
          console.log(err)
        })
      }
    }
  }

}
</script>
